import React from 'react';
import {
  Accordion,
  Button,
  Checkbox,
  Divider,
  Grid,
  Icon,
} from 'semantic-ui-react';
import { Field } from 'redux-form';
import moment from 'moment';
import PropTypes from 'prop-types';

import { FilterEnum, UpdateBidDetailsEnum } from 'Common/FieldEnum';
import { DatePickerField, SelectField } from 'Common/SemanticWrapper';
import { DatePickerCustomButton } from 'Components';
import { makeOptionsData } from 'Common/FormHelper';
import { GenericFiltersContainer } from 'Components/filters/container';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';

import BidDetailsInfoContainer from '../containers/BidDetailsInfo';

const BulkUpdateBidDetailsComponent = props => {
  const {
    assignItemsBidGroupData,
    assignItemsItemGroupData,
    assignItemsVendorData,
    acctCategoryData,
    bidDetailsData,
    loadingBidDetails,
    handleChange,
    filterValues,
    clearFilters,
    handleAsOfDateChange,
    isAsOfDateChecked,
    handleAsOfDateCheckBoxChange,
    handleVendorChange,
    handleClick,
    activeIndexes,
    sorted,
    filtered,
    onSortedChange,
    onFilteredChange,
  } = props;

  const fields = [
    {
      name: FilterEnum.GroupId_Bid,
      component: SelectField,
      type: 'text',
      options: makeOptionsData(assignItemsBidGroupData),
      label: 'BID GROUP',
    },
    {
      name: FilterEnum.GroupId_Item,
      component: SelectField,
      type: 'text',
      options: makeOptionsData(assignItemsItemGroupData),
      label: 'ITEM GROUP',
    },
    {
      name: FilterEnum.GroupId_Cat,
      component: SelectField,
      type: 'text',
      options: makeOptionsData(acctCategoryData),
      label: 'ACCT. CATEGORY',
    },
  ];

  return (
    <Grid>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(0) !== -1}
          index={0}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Filter By</span>
        </Accordion.Title>
        <Accordion.Content active={activeIndexes.indexOf(0) !== -1}>
          <Grid className={'remove-spacing'}>
            <GenericFiltersContainer
              fields={fields}
              onChange={handleChange}
              filterValues={filterValues}
            />
            <Grid.Row columns={3}>
              <Grid.Column>
                <Field
                  name={FilterEnum.VendorId}
                  component={SelectField}
                  type={'text'}
                  options={makeOptionsData(assignItemsVendorData)}
                  label={'Distributor'}
                  onChange={(event, newValue, previousValue, name) =>
                    handleVendorChange(event, newValue, previousValue, name)
                  }
                />
              </Grid.Column>

              <Grid.Column
                width={1}
                verticalAlign={'bottom'}
                style={{
                  marginBottom: 14,
                }}
              >
                <Checkbox
                  name={'Checkbox'}
                  checked={isAsOfDateChecked}
                  onChange={(e, data) => handleAsOfDateCheckBoxChange(e, data)}
                />
              </Grid.Column>
              <Grid.Column
                width={6}
                style={{
                  paddingLeft: 0,
                }}
              >
                <Field
                  component={DatePickerField}
                  label={'As of Date:'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={UpdateBidDetailsEnum.AsOfDate}
                  minDate={moment()}
                  type={'text'}
                  dropdownMode="select"
                  customInput={<DatePickerCustomButton />}
                  onChange={handleAsOfDateChange}
                />
              </Grid.Column>
              <Grid.Column />
            </Grid.Row>
            <Grid.Row width={2}>
              <Grid.Column width={10} />
              <Grid.Column width={6}>
                <Button
                  className={'clear-filters-button'}
                  content="Clear Filters"
                  type={'button'}
                  onClick={clearFilters}
                />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
      <Accordion fluid styled>
        <Accordion.Title
          active={activeIndexes.indexOf(1) !== -1}
          index={1}
          onClick={handleClick}
        >
          <Icon name="dropdown" />
          <span className="text-orange">Update BID PRICE time frame</span>
        </Accordion.Title>
        <Accordion.Content active={activeIndexes.indexOf(1) !== -1}>
          <Grid>
            <Grid.Row columns={4}>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  label={'Begin Date:'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={UpdateBidDetailsEnum.BidPriceBeginDate}
                  type={'text'}
                  dropdownMode="select"
                  customInput={<DatePickerCustomButton />}
                  disabled={loadingBidDetails}
                  maxLength={15}
                />
              </Grid.Column>
              <Grid.Column>
                <Field
                  component={DatePickerField}
                  label={'End Date:'}
                  dateFormat={DATE_FORMAT_FOR_UI}
                  name={UpdateBidDetailsEnum.BidPriceEndDate}
                  type={'text'}
                  dropdownMode="select"
                  customInput={<DatePickerCustomButton />}
                  disabled={loadingBidDetails}
                  maxLength={15}
                />
              </Grid.Column>
              <Grid.Column />
              <Grid.Column />
            </Grid.Row>
          </Grid>
        </Accordion.Content>
      </Accordion>
      <Divider horizontal />
      <Grid.Row>
        <Grid.Column>
          <Field
            component={BidDetailsInfoContainer}
            name={UpdateBidDetailsEnum.BidDetailsInfo}
            {...{
              dataSource: bidDetailsData,
              loadingBidDetails,
              sorted,
              filtered,
              onSortedChange,
              onFilteredChange,
            }}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

BulkUpdateBidDetailsComponent.propTypes = {
  assignItemsBidGroupData: PropTypes.array.isRequired,
  assignItemsItemGroupData: PropTypes.array.isRequired,
  assignItemsVendorData: PropTypes.array.isRequired,
  bidDetailsData: PropTypes.array.isRequired,
  acctCategoryData: PropTypes.array.isRequired,
  handleChange: PropTypes.func,
  filterValues: PropTypes.object,
  clearFilters: PropTypes.func,
  handleAsOfDateCheckBoxChange: PropTypes.func,
  handleVendorChange: PropTypes.func,
  handleClick: PropTypes.func,
  onSortedChange: PropTypes.func,
  onFilteredChange: PropTypes.func,
  handleAsOfDateChange: PropTypes.func,
  onSubmit: PropTypes.func,
  loadingBidDetails: PropTypes.bool,
  isAsOfDateChecked: PropTypes.bool,
  activeIndexes: PropTypes.array,
  sorted: PropTypes.array,
  filtered: PropTypes.array,
};

BulkUpdateBidDetailsComponent.defaultProps = {
  handleChange: () => {},
  filterValues: {},
  clearFilters: () => {},
  handleAsOfDateChange: () => {},
  handleAsOfDateCheckBoxChange: () => {},
  handleVendorChange: () => {},
  handleClick: () => {},
  onSortedChange: () => {},
  onFilteredChange: () => {},
  loadingBidDetails: false,
  isAsOfDateChecked: false,
  activeIndexes: [],
  sorted: [],
  filtered: [],
};
export default BulkUpdateBidDetailsComponent;



// WEBPACK FOOTER //
// ./src/pages/utilities/updatebiddetails/components/UpdateBidDetails.js